import { SafariObjectId } from '../../../base-object/models/app/safari-object-base';

export class PermissionsSet {
  id: SafariObjectId;
  isAdmin?: boolean;
  isCoordinator: boolean;
  hasAccessToAllMatterSubtypes: boolean;
  roles: string[];
}
